import { ApiService } from 'services/api.service'

import { CaptchaApi } from './CaptchaApi'
import { CommonApi } from './CommonApi'
import { ConfigApi } from './ConfigApi'
import { EventsApi } from './EventsApi'
import { PaymentsApi } from './PaymentsApi'
import { SubscriptionsApi } from './SubscriptionsApi'
import { UserApi } from './UserApi'
import { Web2WaveApi } from './Web2WaveApi'
import { ZendeskApi } from './ZendeskApi'

/**
 * API_PREFIX - declare in webpack.config.js as a global variable
 */
declare const API_PREFIX: string

export const baseApiService = new ApiService(API_PREFIX)
export const commonApiService = new ApiService('/api')
export const hooksApiService = new ApiService('/hooks')
export const userApiService = new ApiService('/landing')
export const captchaApiService = new ApiService('/recaptcha')
export const zendeskApiService = new ApiService('')
export const web2waveApiService = new ApiService('')

export const eventsApi = new EventsApi(hooksApiService)
export const configApi = new ConfigApi(baseApiService)
export const commonApi = new CommonApi(commonApiService)
export const userApi = new UserApi(userApiService)
export const captchaApi = new CaptchaApi(captchaApiService)
export const zendeskApi = new ZendeskApi(zendeskApiService)
export const subscriptionsApi = new SubscriptionsApi(commonApiService)
export const paymentsApi = new PaymentsApi(userApiService)
export const web2waveApi = new Web2WaveApi(web2waveApiService)
